import TreeView from '../../../common/components/page/sidebar/treeView/TreeView'
/**
 * This Tree component will create Flatten tree.
 * Please visit mock link https://www.figma.com/file/VvDs58zKzkQ8Oif4JAGomM/Tenant-Switcher-Options?node-id=14%3A4567
 */


/**
 *
 * @param flattenTree
 * @param sgKeyBy
 * @param selectedTreeNode
 * @param onBreadCrumbClick
 * @param dispatch
 * @param globalDispatch
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
const TreeComponent = ({ flattenTree, sgKeyBy, selectedTreeNode, onBreadCrumbClick, dispatch, globalDispatch, ...rest }) => {
  /**
   * =============== CALLBACK ================
   */
  const onInstanceSelection = (tenantSearchValue) => {
    // Need to write Instance propagation logic
  }
  return (
    <TreeView
      globalDispatch={globalDispatch}
      treeData={flattenTree}
      treeKey={Object.keys(sgKeyBy)}
      selectedTreeNode={selectedTreeNode}
      dispatch={dispatch}
      handleTreeNodeClick={onBreadCrumbClick}
      handleInstanceSelection={onInstanceSelection}
      {...rest}>
    </TreeView>
  )
}

export default TreeComponent
